const PUBLIC_MERCHANT_ID = process.env.NEXT_PUBLIC_MERCHANT_ID;
const PUBLIC_COMMISSION_URL = process.env.NEXT_PUBLIC_COMMISSION_URL;
const WS_ANT_DOCUMENTS_URL = process.env.NEXT_PUBLIC_WS_ANT_DOCUMENTS_URL;

export { PUBLIC_MERCHANT_ID, WS_ANT_DOCUMENTS_URL, PUBLIC_COMMISSION_URL };
